import { createApp } from 'vue';
import App from './src/App.vue';
import PrimeVue from 'primevue/config';
import { router } from './src/router';
import { createI18n, fetchBrowserLanguage } from '@centric-os/platform/i18n';
import { registerAppComponents } from './src/components';
import { ToastService } from '@centric-os/components/src/core/messages/toast';
import { DocumentTitleLocaleKey } from '@centric-os/components/src/core/containers/pages/page/injection-keys';
import { ConfirmationService } from '@centric-os/components/src/core/overlays/confirm-dialog';
import emitter, { GlobalEmitterKey } from './src/emitter';
import '@centric-os/styles';
import stores from './src/store';
import { createBreakpoints } from '@centric-os/helpers';
import JsonViewer from 'vue3-json-viewer';
import Tooltip from 'primevue/tooltip';
import { DomHandler } from 'primevue/utils';
import { primeVueLocales } from '@centric-os/platform/i18n/helpers/prime-vue-locales';

const urlParams = new URLSearchParams(globalThis.window.location.search);
const queryParams = Object.fromEntries(urlParams.entries());
const locale = fetchBrowserLanguage(queryParams);

const app = createApp(App);
app.use(PrimeVue, { ripple: true, locale: primeVueLocales[locale] });
app.use(router);
app.use(stores);
const i18n = createI18n({
  locale,
});
app.use(i18n);
app.use(ConfirmationService);
app.use(ToastService);
app.use(
  createBreakpoints({
    sm: 425,
    md: 768,
    lg: 1024,
    xl: 1440,
    xxl: 1920,
    xxxl: 2560,
  }),
);

app.use(JsonViewer);

app.provide(GlobalEmitterKey, emitter);
app.provide(DocumentTitleLocaleKey, {
  wrapperKey: 'documentTitleWrapper',
});

function getTarget(el: HTMLElement) {
  return DomHandler.hasClass(el, 'p-inputwrapper') ? DomHandler.findSingle(el, 'input') : el;
}

app.directive('tooltip', {
  mounted(el: HTMLElement) {
    const target = getTarget(el);
    target.$_ptooltipZIndex ??= app.config.globalProperties.$primevue.config.zIndex.tooltip;
  },
  ...Tooltip,
});

registerAppComponents(app);

app.mount('#app');

export * from './src/components/header-bar/hooks';
export * from './src/composables';
export * from './src';
